// extracted by mini-css-extract-plugin
export default {"pageMask":"ImagePopup_pageMask__6F11Q","contentBox":"ImagePopup_contentBox__RB7xo"};